import { render, staticRenderFns } from "./doubleBar.vue?vue&type=template&id=2ec19458"
import script from "./doubleBar.vue?vue&type=script&lang=js"
export * from "./doubleBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec19458')) {
      api.createRecord('2ec19458', component.options)
    } else {
      api.reload('2ec19458', component.options)
    }
    module.hot.accept("./doubleBar.vue?vue&type=template&id=2ec19458", function () {
      api.rerender('2ec19458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/echarts/bar/components/doubleBar.vue"
export default component.exports